// Fetch wrapper that redirects to login on session expiry
export async function apiFetch(url, options = {}) {
  const res = await fetch(url, options)
  if (res.status === 401) {
    window.location.href = '/auth/login'
    throw new Error('Unauthenticated')
  }
  return res
}
